import React, { useEffect, useState } from "react";
import "./productModeFilter.css";
import { Button } from "@mui/material";
import { useIsMobile } from "../../../../../hooks/useIsMobile";
import { useNitroStore } from "../../../../../store/Store";
import { useNitroCAStore } from "../../../../../store/CompetitiveAnalysisStore";

interface ProductPillFilterProps {
  products: string[];
  selectedProduct: string;
  disabled?: boolean;
  setSelectedProduct: (product: string) => void;
}

const ProductPillFilter: React.FC<ProductPillFilterProps> = ({
  products,
  selectedProduct,
  disabled = false,
  setSelectedProduct,
}) => {
  const isMobile = useIsMobile(400);
  const [startIndex, setStartIndex] = useState(0);
  const itemsToShow = isMobile ? 1 : 6;
  const [product, setProduct] = useNitroStore((states) => [
    states.product,
    states.setProduct,
  ]);
  const [setDisplayFreightDetailsPanel] = useNitroCAStore((states) => [
    states.setDisplayRailFreightDetailsPanel,
  ]);

  useEffect(() => {
    if (product !== selectedProduct) {
      setProduct(selectedProduct);
    }
  }, [product, selectedProduct, setProduct]);

  const showNext = () => {
    if (startIndex < products.length - itemsToShow) {
      setStartIndex(startIndex + 1);
    }
  };

  const showPrevious = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const visibleProducts = products.slice(startIndex, startIndex + itemsToShow);

  return (
    <div className="product-filter-container">
      <span className={`filter-label ${!isMobile ? "margin-left-40" : ""}`}>
        Products
      </span>
      <div className="control-container">
        {startIndex > 0 && (
          <Button onClick={showPrevious} className="arrow" disabled={disabled}>
            &lt;
          </Button>
        )}

        {visibleProducts.map((p) => (
          <Button
            key={p}
            className={`product-filter-button ${
              selectedProduct === p ? "selected" : ""
            }`}
            sx={{ color: "#475569" }}
            disabled={disabled}
            onClick={() => {
              setDisplayFreightDetailsPanel(false);
              setSelectedProduct(p);
            }}
          >
            {p}
          </Button>
        ))}

        {startIndex < products.length - itemsToShow && (
          <Button onClick={showNext} className="arrow" disabled={disabled}>
            &gt;
          </Button>
        )}
      </div>
    </div>
  );
};

export default ProductPillFilter;
